module.exports = __webpack_public_path__ + "static/05-5ad58e8855ce209bc3b42a8354383174.jpg";